export default "__VITE_ASSET__ClzpZe9y__"